import { Users, Maximize2 } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { useSite } from "@/context/SiteContext";
import { Container, SectionHeader, LLink, ArrowLink, BookButton } from "@/components/common";
import { Reveal } from "@/components/motion/Reveal";

export function RoomCard({ room, index = 0, className = "" }) {
  const { t, L } = useLang();
  return (
    <Reveal delay={index * 0.08} className={`group ${className}`}>
      <LLink to="roomDetail" params={{ slug: room.slug }} data-testid={`room-card-${room.slug}`} className="block">
        <div className="img-zoom aspect-[4/5] bg-stone">
          <img src={room.image} alt={L(room.name)} loading="lazy" className="h-full w-full object-cover" />
        </div>
        <div className="mt-5 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-serif text-2xl leading-tight text-charcoal">{L(room.name)}</h3>
            <div className="mt-2 flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.18em] text-charcoal/50">
              <span className="inline-flex items-center gap-1.5"><Maximize2 size={11} /> {room.surface}</span>
              <span className="inline-flex items-center gap-1.5"><Users size={11} /> {room.occupancy} {t.rooms.guests}</span>
            </div>
          </div>
          <span className="font-mono text-[10px] text-terra pt-1">0{index + 1}</span>
        </div>
        <p className="mt-3 text-sm leading-relaxed text-charcoal/65 line-clamp-2">{L(room.description)}</p>
        <div className="mt-4"><ArrowLink>{t.home.detail}</ArrowLink></div>
      </LLink>
    </Reveal>
  );
}

export function RoomsSpotlight() {
  const { t } = useLang();
  const { rooms } = useSite();
  return (
    <section data-testid="home-rooms" className="bg-bone py-20 md:py-32">
      <Container>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <SectionHeader eyebrow={t.home.roomsEyebrow} title={t.home.roomsTitle} text={t.home.roomsText} />
          <div className="flex flex-wrap gap-4">
            <LLink to="rooms" data-testid="rooms-see-all" className="btn btn-outline">{t.home.roomsCta}</LLink>
            <BookButton testId="rooms-book-button" />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {rooms.map((r, i) => <RoomCard key={r.id} room={r} index={i} className={i % 2 === 1 ? "lg:mt-16" : ""} />)}
        </div>
      </Container>
    </section>
  );
}
